module.exports = __webpack_public_path__ + "img/img-1.3945e78a.png";